import { ErrorTracker } from '../error-tracker';

export enum LogLevel {
  DEBUG,
  INFO,
  WARN,
  ERROR
}

/**
 * Singleton to handle logging at different levels across the app.
 */
export class Logger {

  public static level: LogLevel = LogLevel.INFO;

  /**
   * Logs an info message.
   *
   * @param {string} message
   */
  public static info(message: string): void {
    Logger.log(LogLevel.INFO, message);
  }

  /**
   * Logs an error message.
   *
   * @param {string} message
   */
  public static error(message: string): void {
    Logger.log(LogLevel.ERROR, message);
    ErrorTracker.captureMessage(message, ErrorTracker.level.Error);
  }

  /**
   * Logs a debug message.
   *
   * @param {string} message
   */
  public static debug(message: string): void {
    Logger.log(LogLevel.DEBUG, message);
  }

  /**
   * Logs a warning message.
   *
   * @param {string} message
   */
  public static warn(message: string): void {
    Logger.log(LogLevel.WARN, message);
  }

  /**
   * Log the given message at the provided level.
   *
   * @param {LogLevel} level
   * @param {string} message
   */
  public static log(level: LogLevel, message: string): void {
    if (Logger.level <= level) {
      /* eslint-disable-next-line no-console */
      console.log(`[${Logger.getTimestamp()}] [${LogLevel[level]}] - ${message}`);
    }
  }

  /**
   * Get the current timestamp. formatted as [HH:MM:SS:ms]
   *
   * @returns {string}
   */
  public static getTimestamp(): string {
    return new Date().toISOString();
  }

}
